import { render, staticRenderFns } from "./PropertyValue.vue?vue&type=template&id=3a19bdbe&scoped=true"
import script from "./PropertyValue.vue?vue&type=script&lang=js"
export * from "./PropertyValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a19bdbe",
  null
  
)

export default component.exports